// extracted by mini-css-extract-plugin
export default {"chart":"StatProspect_chart__KK9wp","legend":"StatProspect_legend__tit-B","title":"StatProspect_title__Lg4Qg","percent":"StatProspect_percent__uL-VL"};